import { useState } from "react";

import { dateFormat } from "common/dateFormat";
import { SortOrder } from "common/SortOrder";
import { Icon, SortIcon } from "components/icon/Icon";
import { ArchiveItem } from "models/ArchiveItem";
import { Tooltip } from "components/tooltip/Tooltip";

export type SortDocumentFunction = (a: ArchiveItem, b: ArchiveItem) => number;

export function SortByDate(a: ArchiveItem, b: ArchiveItem) {
  return a && b && a.createdAt > b.createdAt ? -1 : 1;
}

export function SortByName(a: ArchiveItem, b: ArchiveItem) {
  return a && b && a.name > b.name ? -1 : 1;
}

export function SortByCreatedBy(a: ArchiveItem, b: ArchiveItem) {
  return a && b && a.createdBy && b.createdBy && a.createdBy > b.createdBy
    ? -1
    : 1;
}

type DocumentArchiveFileTableExternalProps = {
  files: ArchiveItem[];
  onDownloadFile: (document: ArchiveItem) => void;
};

export function DocumentArchiveFileTableExternal({
  files,
  onDownloadFile
}: DocumentArchiveFileTableExternalProps) {
  const [sortFunction, setSorting] = useState<SortDocumentFunction>(
    () => SortByName
  );
  const [sortOrder, setSortOrder] = useState(SortOrder.Descending);
  const setSortingFn = (selectedSortFn: SortDocumentFunction) => {
    setSortOrder(
      sortFunction === selectedSortFn && sortOrder === SortOrder.Descending
        ? SortOrder.Ascending
        : SortOrder.Descending
    );
    setSorting(() => selectedSortFn);
  };

  if (files.length === 0) {
    return <>Här var det tomt!</>;
  }

  return (
    <table data-testid="document-archive-table">
      <thead>
        <tr>
          <th
            className="cursor-pointer"
            onClick={() => setSortingFn(SortByName)}
          >
            <div className="d-flex">
              Namn
              <SortIcon
                className="ml-2"
                sortOrder={sortFunction === SortByName ? sortOrder : ""}
              />
            </div>
          </th>
          <th
            className="cursor-pointer"
            onClick={() => setSortingFn(SortByDate)}
          >
            <div className="d-flex">
              Uppladdat datum
              <SortIcon
                className="ml-2"
                sortOrder={sortFunction === SortByDate ? sortOrder : ""}
              />
            </div>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {files
          .sort((a, b) => {
            return (
              sortFunction(a, b) * (sortOrder === SortOrder.Descending ? 1 : -1)
            );
          })
          .map((file) => (
            <tr key={file.id}>
              <td>{file.name}</td>
              <td>{dateFormat(file.createdAt)}</td>
              <td>
                <Tooltip
                  className="mr-3"
                  content={<p className="m-0">Ladda ned filen</p>}
                >
                  <Icon
                    className="cursor-pointer"
                    name="download"
                    onClick={() => onDownloadFile(file)}
                  />
                </Tooltip>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}
